(function (ng, app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Contacts.ContactView",
                    {
                        url: "/Contact/{contactId}",
                        component: "contactView",
                        PageTitle: "Contact | Marketing Tracker",
                        redirectTo: "Home.Tools.MarketingTrackerNew.Contacts.ContactView.TimelineView"
                    });
        }
    ]);


    app
        .component("contactView",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Contacts/ContactView/contact-view-template.html",
                controller: contactViewController
            });

    contactViewController.$inject = ["featureToggleService", "$stateParams", "figToaster", "marketingTrackerContactApi"];
    function contactViewController(featureToggleService, $stateParams, figToaster, marketingTrackerContactApi) {
        var $ctrl = this;
        ng.extend($ctrl,
            {
                ui: {
                    editing: false,
                    loadingData: false,
                    contactUpdates: {}
                },
                //rmeActivities: [
                //    {
                //        EventDate: '2019-04-15T13:21:00.000Z',
                //        Attended: true,
                //        Title: 'Dinner Seminar', 
                //        Status: 'Reserved'
                //    },
                //    {
                //        EventDate: '2019-01-15T13:35:00.000Z',
                //        Attended: true,
                //        Title: 'Ruths Cris Dinner Seminar', 
                //        Status: 'Cancelled'
                //    },
                //    {
                //        EventDate: '2019-07-15T13:51:00.000Z',
                //        Attended: true,
                //        Title: 'Meeting', 
                //        Status: 'Reserved'
                //    }
                //],
                //actOnActivities: [
                //    {
                //        activity_date: '2019-03-15T11:31:00.000Z',
                //        attended: true,
                //        event_name: 'Dinner Seminar'
                //    },
                //    {
                //        activity_date: '2019-04-15T14:31:00.000Z',
                //        attended: false,
                //        event_name: 'Dinner with friends'
                //    }
                //],
                statuses: ['Lead', 'Prospect', 'Client'],
                updateContact: updateContact
            });
        
        function updateContact() {
            var message = "", toastClass = "";
            $ctrl.ui.saving = true;
            marketingTrackerContactApi.updateContact($ctrl.contactId, $ctrl.ui.contactUpdates)
                .then(function () {
                    message = "Changes saved.";
                    toastClass = "is-success";
                })
                .catch(function (error) {
                    console.log("Error: " + error.data);
                    message = "There was a problem updating your data. Please try again shortly.";
                    toastClass = "is-error";
                })
                .finally(function () {
                    $ctrl.ui.saving = false;
                    $ctrl.ui.editing = false;
                    _getContact($ctrl.contactId);
                    return figToaster.showSimple(message, "top", toastClass);
                });

        }

        function _getContact(contactId) {
            $ctrl.ui.loadingData = true;
            //if (!$stateParams.contact) {
            marketingTrackerContactApi.getContactById(contactId)
                .then(function (response) {
                    $ctrl.contact = response;
                    //if (response.ConstantContactId) {
                    //    _getConstantContactActivity(response.ConstantContactId);
                    //}
                    //if (response.ActOnId) {
                    //    _getActOnActivity(response.ActOnId);
                    //}
                    //if (response.RmeId) {
                    //    _getRMEActivity(response.RmeId);
                    //}
                }).catch(function (error) {
                    console.log("Error: " + error.data);
                    message = "There was a problem retrieving your data. Please try again shortly.";
                    toastClass = "is-error";
                    figToaster.showSimple(message, "top", toastClass);
                })
                .finally(function () {
                    $ctrl.ui.contactUpdates = ng.copy($ctrl.contact);
                    $ctrl.ui.loadingData = false;
                });


            //} else {
            //    $ctrl.contact = $stateParams.contact;
            //    $ctrl.ui.contact = $ctrl.contact;
            //    $ctrl.ui.loadingData = false;
            //}
        }

        //function _getConstantContactInfo(constantContactId) {
        //    marketingTrackerConstantContactApi.getConstantContactContactById(constantContactId)
        //        .then(function (response) {
        //            //$ctrl.contact.ConstantContactInfo = response;
        //        })
        //        .catch(function () {
        //            console.log("Error: " + data);
        //            message = "There was a problem retrieving your data. Please try again shortly.";
        //            toastClass = "is-error";
        //            figToaster.showSimple(message, "top", toastClass);
        //        })
        //        .finally(function () {
        //            $ctrl.ui.loadingData = false;
        //        });
        //}

        //function _getRMEInfo(rmeId) {
        //}

        //function _getActOnInfo(actOnId) {
        //    marketingTrackerActOnApi.getActOnContactById(actOnId)
        //        .then(function (response) {
        //            $ctrl.contact.ActOnInfo = response;
        //        })
        //        .catch(function () {
        //            console.log("Error: " + data);
        //            message = "There was a problem retrieving your data. Please try again shortly.";
        //            toastClass = "is-error";
        //            figToaster.showSimple(message, "top", toastClass);
        //        })
        //        .finally(function () {
        //            $ctrl.ui.loadingData = false;
        //        });
        //}
        
        //$ctrl.refreshData = function () {
        //    $ctrl.ui.loadingData = true;
        //    $ctrl.ui.loadingActivity = true;
        //    $timeout(function () {
        //        _getContact($ctrl.contactId);
        //    }, 1000)
        //        .finally(function () {
        //            $ctrl.ui.loadingData = false;
        //            $ctrl.ui.loadingActivity = false;
        //        });
        //};
        $ctrl.$onInit = function () {
            $ctrl.contactId = $stateParams.contactId;
            _getContact($stateParams.contactId);
            $ctrl.toggleFeature = featureToggleService.checkEnv();
        };
    }

})(window.angular, window.app); //jshint ignore:line